import { c as _c } from "react/compiler-runtime";
import { OutpostDestinationTypeMetadata } from '../../../../../../../typings/outpost';
import Icon, { IconName } from '../../../common/base/Icon';
import { Div } from '../../../common/helpers/StyledUtils';

/**
 * Renders the icon for an Outpost destination type.
 * Uses the type's SVG from API metadata when available (e.g. GCP Pub/Sub);
 * otherwise falls back to the Icon component by type name.
 */
export const DestinationTypeIcon = t0 => {
  const $ = _c(9);
  const {
    type,
    type_meta,
    small: t1
  } = t0;
  const small = t1 === undefined ? true : t1;
  if (type_meta?.icon) {
    let t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        align: "center",
        justify: "center"
      };
      t3 = {
        width: 16,
        height: 16
      };
      $[0] = t2;
      $[1] = t3;
    } else {
      t2 = $[0];
      t3 = $[1];
    }
    let t4;
    if ($[2] !== type_meta.icon) {
      t4 = <Div as="span" flex={t2} style={t3} dangerouslySetInnerHTML={{
        __html: type_meta.icon
      }} />;
      $[2] = type_meta.icon;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    return t4;
  }
  let t2;
  if ($[4] !== type) {
    t2 = type.toLowerCase().replace(/\//g, "_") as IconName || "destination";
    $[4] = type;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== small || $[7] !== t2) {
    t3 = <Icon icon={t2} small={small} />;
    $[6] = small;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};